var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { WidgetWrapper } from "./widget-wrapper";
export var WidgetCard = function (_a) {
    var header = _a.header, chart = _a.chart, table = _a.table, isLoading = _a.isLoading, isEmpty = _a.isEmpty, style = _a.style, wrapper = _a.wrapper;
    var toBeRender = null;
    if (isLoading) {
        toBeRender = React.createElement(WidgetWrapper, { type: 'load' });
    }
    else if (isEmpty) {
        toBeRender = React.createElement(WidgetWrapper, { type: 'info', title: 'There is no data available matching the criteria.', image: 'man-women' });
    }
    else if (wrapper) {
        toBeRender = React.createElement(React.Fragment, null, wrapper);
    }
    else {
        toBeRender = React.createElement(React.Fragment, null,
            chart,
            " ",
            table);
    }
    return (React.createElement("div", { className: "widget-container", style: __assign({ display: "flex", height: '100%', flexDirection: 'column', flex: 1 }, style) },
        React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } }, header),
        React.createElement("div", { style: { flex: 1, position: 'relative', display: 'flex', flexDirection: 'column', overflow: 'hidden' } }, toBeRender)));
};
//# sourceMappingURL=widget-card.js.map